module.exports = __webpack_public_path__ + "static/media/tshirt1.f9127912.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/Images/tshirt1.PNG
// module id = 28
// module chunks = 0